import { render, staticRenderFns } from "./CellRendererAttachment.vue?vue&type=template&id=212c6efe"
import script from "./CellRendererAttachment.vue?vue&type=script&lang=js"
export * from "./CellRendererAttachment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports